









































































import ProductListLayout from "./ProductListLayout.vue";
import ProductTile from "./ProductTile.vue";
import FilterBar from "./FilterBar.vue";
import ActiveFilters from "./ActiveFilters.vue";
import FilterOverlay from "./FilterOverlay.vue";
import Config, { Mode } from '@/models/config.model';
import Product from '@/models/product.model';
import FilterGroup from '@/models/filter-group.model';
import Translations from '@/models/translations.model';

export default {
  name: "ProductList",
  components: {
    ProductListLayout,
    ProductTile,
    FilterBar,
    ActiveFilters,
    FilterOverlay,
  },
  data() {
    return {
      productTileModule: null,
      productListingInstance: null,
      isInitialized: false,
    };
  },
  computed: {
    config(): Config {
      return this.$store.state.config;
    },
    isFilterMode(): boolean {
      return this.config.mode === Mode.Filter;
    },
    isMatnoMode(): boolean {
      return this.config.mode === Mode.Matno;
    },
    isMatnoReducedMode(): boolean {
      return this.config.mode === Mode.MatnoReduced;
    },
    /**
     * Returns an array of filter groups
     */
    filters(): Array<FilterGroup> {
      return this.$store.state.filters;
    },
    /**
     * Returns the product sorting
     */
    productSorting(): string {
      return this.$store.state.productSorting;
    },
    /**
     * Returns an array of products based
     * on filtering, sorting and chunking
     **/
    chunkedProducts(): Array<Product> {
      return this.$store.getters.chunkedProducts;
    },
    /**
     * Returns the length
     * of the limited products
     * array
     */
    chunkedProductsLength(): number {
      return this.chunkedProducts.length;
    },
    /**
     * Returns the length
     * of the filtered products
     * array
     */
    totalProductsLength(): number {
      return this.$store.getters.sortedProducts.length;
    },
    /**
     * Returns the length
     * of the rentable products
     * array
     */
     productsRentalLength(): number {
      return this.$store.state.productsRental.length;
    },
    /**
     * Returns the percentage
     * CSS width string
     * for the progress bar 
     **/
    progressBarWidth(): string {
      const decimal = this.chunkedProductsLength / this.totalProductsLength;
      const clampedDecimal = Math.min(1, Math.max(decimal, 0));
      const percentage = clampedDecimal * 100;
      const cssWidth = `${percentage}%`;
      return cssWidth;
    },
    translations(): Translations {
      return this.$store.state.translations;
    },
    seenAllResultsText(): string {
      return this.translations.seenAllResults
        .replace("{PRODUCTS_COUNT}", this.totalProductsLength);
    },
    seenFromResultsText(): string {
      return this.translations.seenFromResults
        .replace("{PRODUCTS_SEEN_COUNT}", this.chunkedProductsLength)
        .replace("{PRODUCTS_COUNT}", this.totalProductsLength);
    },
    productTileClass(): Function {
      return this.productTileModule.ProductTileVue;
    }
  },
  methods: {
    async init() {
      const [productListingInstance, productTileModule] = await Promise.all([
        this.createProductListingInstance(),
        this.loadProductTileModule(),
        this.loadCampaignTeaserModule(),
      ]);

      this.productListingInstance = productListingInstance;
      this.productTileModule = productTileModule;
      this.isInitialized = true;
      
      window.Miele.Footnotes.ready().then(function (footnotes) {
        footnotes.addContentArea('#product-filter-app');
      });
    },
    /**
     * Loads the product listing module
     * using the ModuleLoader and creates
     * an instance
     */
    createProductListingInstance() {
      return Miele.ModuleLoader.createModuleInstance("pwp:modules/products/listing", this.$el, {
        initTiles: false
      });
    },
    /**
     * Imports the product tile module
     * using the ModuleLoader so
     * it can be passed to the product tiles
     */
    async loadProductTileModule() {
      return Miele.ModuleLoader.importModule("pwp:modules/products/tile");
    },
    /**
     * Trigger increment of the productLimit
     **/
    showMoreProducts(): void {
      this.$store.dispatch("showMoreProducts");
    },
    /**
     * Show all products
     */
    showAllProducts(): void {
      this.$store.dispatch("showAllProducts");
    },
    /**
     * Handles the 'sort-change'
     * event of the ProductFilterBar
     * component
     **/
    handleSortChange(productSorting: string): void {
      this.$store.dispatch("setProductSorting", productSorting);
    },
    /**
     * Handels the Campaign Teaser Issue
     */
    handleCampaignTeaser(): void {
      const productsList = document?.querySelector('.mdl-product-listing__grid') as HTMLElement;

      if (!productsList) return;

      const productTile = productsList?.querySelectorAll('.crd-product-tile');

      if (!productTile) return;

      productTile.forEach((p, i) => {
        if (i == 1) {
          this.createCampaignTeaser(p, 'mdl-product-listing__grid-teaser--mobile')
        }
        if (i == 2) {
          this.createCampaignTeaser(p, 'mdl-product-listing__grid-teaser--desktop')
        }
        
      });
    },
    /**
     * Creates a teaser if exists
     *
     **/
    createCampaignTeaser(productTilte: HTMLElement, teaserClass: string): void {
      const campaignTeaserContainer = document?.getElementById('campaignTeaserContainer');

      if(!campaignTeaserContainer) return;

      const campaignTeaser = campaignTeaserContainer?.querySelector('.mdl-teaser-campaign');

      if(!campaignTeaser) return;

      const clonedCampaignTeaser = campaignTeaser.cloneNode(true);
      const teaserContainer = document.createElement('div');

      teaserContainer.append(clonedCampaignTeaser);
      teaserContainer.classList.add(teaserClass);
      productTilte.after(teaserContainer);
    },
    /**
     * Imports the Campaign Teaser module
     * using the ModuleLoader
     */
     async loadCampaignTeaserModule() {
      return Miele.ModuleLoader.importModule("cl:modules/content/teaser/campaign");
    },
  },
  mounted() {
    this.init();
  },
  updated() {
    this.handleCampaignTeaser();
  },
};
